import Swiper from "swiper";
import SidebarFilter from "../../src/js/components/sidebar-filter";

class ProductCollection {
  constructor() {
    new SidebarFilter();
    this.slidersInit();
  }

  slidersInit = () => {
    const mainSlider = new Swiper(".js-categories-main-slider", {
      slidesPerView: "auto",
    });
    const childSlider = new Swiper(".js-categories-children-slider", {
      slidesPerView: "auto",
    });
  };
}

new ProductCollection();
